import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import HeadPdf from './head-pdf';
import URI from 'urijs';
import FootPdf from './foot-pdf';
import moUser from '@/store/user';

interface IProps {
  url?: string;
  head?: boolean;
  onetitle?: string;
  twotitle?: string;
  foot?: boolean;
  showuuid?: boolean
}
interface IState {}

const StaticPage = (props: IProps, state: IState) => {
  const { head, url, onetitle, twotitle, foot, showuuid } = props;
  const uri = new URI(window.location.href);
  const res: any = uri.query(true);
  const result = res?.data ? decodeURIComponent(res?.data) : '{}';
  const path = JSON.parse(result) ;
  const { useruuid } = moUser;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section
      className="static-detail-page"
      style={{ backgroundImage: `url(${url})`, marginTop: path?.type === 'export'  ? 0 : '20px' }}>
      {head && <HeadPdf onetitle={onetitle} twotitle={twotitle} />}
      {showuuid && <p className='uuid'>{useruuid}</p>}
      {foot && <section className='static-foot'><FootPdf show={foot}/></section>}
    </section>
  );
};

export default observer(StaticPage);
